export default "__VITE_ASSET__CFiYQjl1__"